<template>
  <div class="HelloWorld">HelloWorld</div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped></style>
